import { render, staticRenderFns } from "./notifications-item-study-message.vue?vue&type=template&id=2c756fde&scoped=true"
import script from "./notifications-item-study-message.vue?vue&type=script&lang=js"
export * from "./notifications-item-study-message.vue?vue&type=script&lang=js"
import style0 from "./notifications-item-study-message.vue?vue&type=style&index=0&id=2c756fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c756fde",
  null
  
)

export default component.exports